import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '@/components/Logo';
import { ArrowLeft } from 'lucide-react';
import { SiteFooter } from '@/components/SiteFooter';

// Shared shell for the public About / Privacy / Terms pages.
export const LegalPage = ({ title, updated, children, draft = false }) => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen" style={{ background: 'var(--background)' }}>
      <div className="sticky top-0 z-30" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="mx-auto max-w-3xl px-4 h-16 flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: 'var(--primary)' }} data-testid="legal-back"><ArrowLeft size={18} /> Back</button>
          <Logo size={26} />
        </div>
      </div>

      <article className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="text-3xl font-extrabold tracking-tight" style={{ color: 'var(--text)' }}>{title}</h1>
        {updated && <p className="text-xs mt-2" style={{ color: 'var(--text-muted)' }}>Last updated: {updated}</p>}
        {draft && (
        <div className="mt-3 rounded-xl px-4 py-3 text-xs" style={{ background: 'color-mix(in srgb, var(--warning) 14%, transparent)', color: 'var(--text)', border: '1px solid var(--warning)' }}>
          This is a plain-language draft provided for convenience and is <strong>not legal advice</strong>. Please have it reviewed by a qualified professional before public launch.
        </div>
        )}
        <div className="legal-body mt-6 space-y-5" style={{ color: 'var(--text)' }}>{children}</div>
      </article>

      <SiteFooter />
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="text-lg font-extrabold mb-1.5" style={{ color: 'var(--text)' }}>{heading}</h2>
    <div className="text-sm leading-relaxed space-y-2" style={{ color: 'var(--text-muted)' }}>{children}</div>
  </section>
);
